// Rupee amounts the way they are written in India: 10,00,000.00 and "Ten Lakh Rupees Only".
// Used where an amount is about to be sent as a payment, so a wrong number of zeros is easy to see.

export const formatINR = (n) =>
  `₹${Number(n || 0).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

const ONES = ['', 'One', 'Two', 'Three', 'Four', 'Five', 'Six', 'Seven', 'Eight', 'Nine', 'Ten', 'Eleven', 'Twelve',
  'Thirteen', 'Fourteen', 'Fifteen', 'Sixteen', 'Seventeen', 'Eighteen', 'Nineteen'];
const TENS = ['', '', 'Twenty', 'Thirty', 'Forty', 'Fifty', 'Sixty', 'Seventy', 'Eighty', 'Ninety'];

const below100 = (n) => (n < 20 ? ONES[n] : `${TENS[Math.floor(n / 10)]}${n % 10 ? ` ${ONES[n % 10]}` : ''}`);
const below1000 = (n) => (n >= 100
  ? `${ONES[Math.floor(n / 100)]} Hundred${n % 100 ? ` ${below100(n % 100)}` : ''}`
  : below100(n));

// 1250000 -> "Twelve Lakh Fifty Thousand Rupees Only"; '' for anything that is not a positive amount
export function amountInWords(amount) {
  const n = Math.round(Number(amount) * 100) / 100;
  if (!Number.isFinite(n) || n <= 0) return '';
  let rupees = Math.floor(n);
  const paise = Math.round((n - rupees) * 100);

  const parts = [];
  const crore = Math.floor(rupees / 1e7); rupees %= 1e7;
  const lakh = Math.floor(rupees / 1e5); rupees %= 1e5;
  const thousand = Math.floor(rupees / 1e3); rupees %= 1e3;
  if (crore) parts.push(`${below1000(crore)} Crore`);
  if (lakh) parts.push(`${below100(lakh)} Lakh`);
  if (thousand) parts.push(`${below100(thousand)} Thousand`);
  if (rupees) parts.push(below1000(rupees));

  const rupeeText = parts.length ? (Math.floor(n) === 1 ? 'One Rupee' : `${parts.join(' ')} Rupees`) : '';
  const paiseText = paise ? `${below100(paise)} Paise` : '';
  return `${[rupeeText, paiseText].filter(Boolean).join(' and ')} Only`;
}

// "2026-10-21" -> "21.10.2026" (how the portal's file writes dates)
export const portalDate = (iso) => {
  const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(String(iso || ''));
  return m ? `${m[3]}.${m[2]}.${m[1]}` : '';
};

// Today in the person's own time zone, as YYYY-MM-DD (toISOString would give the UTC day)
export const todayLocal = () => {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
};
